module.exports = __webpack_public_path__ + "media/images/reservation_check_mark-59b334a7085e48ab3631c170ba708236.svg";